import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d5e7d7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal",
  "data-scoped-css-v3": ""
}
const _hoisted_2 = { class: "modal_content theme theme-light--10 p-5 flow flow--5" }
const _hoisted_3 = { class: "modal_header" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("default header")
const _hoisted_5 = { class: "modal_body flow flow--5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("default body")
const _hoisted_7 = { class: "modal_footer" }

import { onBeforeMount, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  show: Boolean,
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const handleEscape = (e: KeyboardEvent) => {
  if (e.key === 'Escape') emit('close');
};

watch(
  () => props.show,
  (value) => {
    if (value) document.addEventListener('keydown', handleEscape);
    else document.removeEventListener('keydown', handleEscape);
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.show)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "modal_background theme theme-dark--10",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
              }, null, 32),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _hoisted_4
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "body", {}, () => [
                    _hoisted_6
                  ])
                ]),
                _createElementVNode("footer", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("button", {
                      class: "button button--primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                    }, "OK")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})